<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="formattedDate"
        v-bind:label="label"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-bind:rules="rules"
        v-on="on"
        outlined
        dense
        clearable
        @click="clearData()"
        @click:clear="clearData()"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      v-model="inputVal"
      v-bind:max="maxDate"
      v-bind:min="minDate"
      :locale="language"
      scrollable
    ></v-date-picker>
  </v-menu>
</template>

<script>
import dayjs from "dayjs";
export default {
  props: {
    value: String,
    label: String,
    rules: Array,
    minDate: {
      type: String,
      default: "2007-01-01",
    },
    maxDate: {
      type: String,
    },
  },

  data: () => ({
    menu: false,
  }),

  computed: {
    language() {
      return this.$root.$i18n.locale;
    },

    formattedDate() {
      if (this.value && this.value !== "0000-00-00 00:00:00") {
        if (this.language === "en")
          return dayjs(this.value, "YYYY-MM-DD HH:mm:ss")
            .locale("en")
            .format("D MMMM YYYY");
        else if (this.language === "th")
          return dayjs(this.value, "YYYY-MM-DD HH:mm:ss")
            .locale("th")
            .format("D MMMM BBBB");
      }
      return "";
    },

    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.menu = false;
      },
    },
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  methods: {
    clearData() {
      this.$emit("input", null);
    },
  },
};
</script>
